<template>
	<div>
		<div
			v-for="(page, index) in pages"
			:key="index"
			class="vfm-item"
			:href="getHref(page)"
			@click.prevent="go(page.fullPath, page.external, page.openInNewTab)"
		>
			{{ page.label }}
		</div>
	</div>
</template>

<script setup lang="ts">
import { Domain, buildUrlForDomain } from '@/routing/helpers/subdomain-helper';
import type { PageListItem } from '@/components/nav/static-pages/types';
import { getJwConfig } from '@/helpers/jw-config';

const { activeDomain = () => [] } = defineProps<{
	pages?: PageListItem[];
	activeDomain?: Domain;
}>();

const emit = defineEmits(['dismiss']);

const jwConfig = getJwConfig();

const router = useRouter();

function getHref(page: PageListItem) {
	if (page.external) return page.fullPath;

	return `https://www.${jwConfig.DOMAIN}${page.fullPath}`;
}

async function go(path: string, external: boolean, openInNewTab = false) {
	if (!import.meta.client) return;

	if (external) {
		if (openInNewTab) {
			window.open(path, '_blank', 'noopener');
		}
		else {
			window.open(path, '_self', 'noopener');
		}
	}
	else if (activeDomain !== Domain.MAIN) {
		// We're on a subdomain, need to redirect to main domain
		const targetUrl = buildUrlForDomain(path, Domain.MAIN);
		window.open(targetUrl, '_self', 'noopener');
	}
	else {
		router.push({ path });
	}

	emit('dismiss');
}
</script>

<style lang="scss">
.static-pages-popover {
	width: 250px;

	.vfm-item {
		padding: 14px;
		font-size: 16px;
		cursor: pointer;
		text-transform: capitalize;
	}
}
</style>
